"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.promise");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _usernameLogin = _interopRequireDefault(require("../../components/username-login"));

var _girderRedux = require("@openchemistry/girder-redux");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var validate = function validate(values) {
  var errors = {};
  var requiredFields = ['username', 'password'];
  requiredFields.forEach(function (field) {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  return errors;
};

var NerscLoginContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(NerscLoginContainer, _Component);

  function NerscLoginContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NerscLoginContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NerscLoginContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClose = function () {
      _this.props.dispatch(_girderRedux.auth.actions.showNerscLogin(false));
    };

    _this.handleLogin = function (values, dispatch) {
      var username = values.username,
          password = values.password,
          mfa = values.mfa;
      var onSubmitPromise = new Promise(function (resolve, reject) {
        dispatch(_girderRedux.auth.actions.nerscLogin({
          username: username,
          password: password,
          mfa: mfa,
          resolve: resolve,
          reject: reject
        }));
      }).then(function (val) {
        dispatch(_girderRedux.auth.actions.showNerscLogin(false));
      }).catch(function (_error) {
        throw new _reduxForm.SubmissionError({
          _error: _error
        });
      });
      return onSubmitPromise;
    };

    _this.render = function () {
      var show = _this.props.show;

      if (!show) {
        return null;
      }

      return _react.default.createElement(_usernameLogin.default, _extends({
        handleClose: _this.handleClose,
        loginFn: _this.handleLogin,
        title: "Sign in using NERSC credentials",
        showMfa: true
      }, _this.props));
    };

    return _this;
  }

  return NerscLoginContainer;
}(_react.Component);

function mapStateToProps(state, ownProps) {
  var show = _girderRedux.auth.selectors.getShowNerscLogin(state);

  return {
    show: show
  };
}

NerscLoginContainer = (0, _reactRedux.connect)(mapStateToProps)(NerscLoginContainer);
NerscLoginContainer = (0, _reduxForm.reduxForm)({
  form: 'nerscLogin',
  validate: validate
})(NerscLoginContainer);
var _default = NerscLoginContainer;
exports.default = _default;